const style = ({ COLORS }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  head: ({ size }) => ({
    padding: `${size(3.5)} ${size(4)}`
  }),
  body: {
    backgroundColor: COLORS.DARK_BLUE.NORMAL,
    display: 'flex',
    flex: '1',
    minHeight: '0'
  },
  video: ({ size }) => ({
    flex: '1',
    padding: `${size(3.5)} ${size(3.5)} ${size(6.6)}`
  }),
  iFrame: ({ size }) => ({
    background: '#000',
    display: 'block',
    width: '100%',
    height: '100%',
    boxShadow: `${size(-0.3)} ${size(0.6)} ${size(0.4)} rgba(0, 0, 0, 0.2)`
  }),
  descHolder: {
    width: '33%',
    height: '100%',
    overflowY: 'auto'
  },
  desc: ({ size }) => ({
    color: '#fff',
    padding: `${size(3.5)} ${size(4)}`
  })
})

export default style
